import ROL from "./rol-values";

export default [
    {header: "Dashboards", roles: [ROL.SITE_USER, ROL.SITE_ADMIN], i18n: "dashboards"}, {
        icon: "mdi-chart-areaspline",
        title: "dashboardCalidadServicio",
        name: "dashboardCalidadServicio",
        roles: [ROL.SITE_USER, ROL.SITE_ADMIN],
        i18n: "dashboard1"
    }, {
        icon: "mdi-chart-gantt",
        title: "dashboardTiempoReal",
        name: "dashboardTiempoReal",
        roles: [ROL.SITE_USER, ROL.SITE_ADMIN, ROL.DISPLAY_USER],
        i18n: "dashboard2"
    }, {
        icon: "mdi-face-agent",
        title: "dashboardAgente",
        name: "dashboardAgente",
        roles: [ROL.SITE_USER, ROL.SITE_ADMIN],
        i18n: "dashboard3"
    }, {
        icon: "mdi mdi-card-account-phone-outline",
        title: "buscadorDetalleLlamada",
        name: "buscadorDetalleLlamada",
        roles: [ROL.SITE_ADMIN, ROL.DISPLAY_USER],
        i18n: "dashboard5"
    }, {
        icon: "mdi mdi-card-account-phone-outline",
        title: "buscadorDetalleLlamadaUser",
        name: "buscadorDetalleLlamadaUser",
        roles: [ROL.SITE_USER],
        i18n: "dashboard6"
    }, {
        icon: "mdi-reload",
        title: "dashboardCicloVida",
        name: "dashboardCicloVida",
        roles: [ROL.EMPTY],
        i18n: "dashboard4"
    },
    {header: "Admin", roles: [ROL.SITE_ADMIN, ROL.SUPER_USER, ROL.SUPER_ADMIN], i18n: "admin"},
    {
        icon: "mdi-phone",
        title: "Nodes",
        name: "adminNodos",
        roles: [ROL.SITE_ADMIN],
        i18n: "nodesManagement"
    }, {
        icon: "mdi-account-supervisor",
        title: "Users",
        name: "adminUsers",
        roles: [ROL.SITE_ADMIN],
        i18n: "usersManagement"
    }, {
        icon: "mdi-lightbulb-group",
        title: "Groups",
        name: "adminGroups",
        roles: [ROL.SITE_ADMIN],
        i18n: "groupsManagement"
    }, {
        icon: "mdi-format-columns",
        title: "Queues",
        name: "QueuesView",
        roles: [ROL.SITE_ADMIN],
        i18n: "queuesView"
    }, {
        icon: "mdi-domain",
        title: "Companies",
        name: "adminCompanies",
        roles: [ROL.SUPER_USER, ROL.SUPER_ADMIN],
        i18n: "companiesManagement"
    },{
        icon: "mdi-account-supervisor",
        title: "SuperUsers",
        name: "adminSuperUsers",
        roles: [ROL.SUPER_USER, ROL.SUPER_ADMIN],
        i18n: "superUsersManagement"
    },
    {header: "Reports", roles: [ROL.SITE_USER, ROL.SITE_ADMIN], i18n: "reports"},
    {
        icon: "mdi-file-chart-outline",
        title: "reportsMaganement",
        name: "reportsMaganement",
        roles: [ROL.SITE_USER, ROL.SITE_ADMIN],
        i18n: "reportsMaganement"
    }
];
